import { createScreenText } from 'helpers/screenText';
const st = createScreenText('service_http_error_message_service');

// src/services/httpError/HttpErrorMessageService.ts
// Ánh xạ HTTP status code -> thông báo lỗi thân thiện bằng tiếng Việt, dùng chung cho TOÀN BỘ API
// call trong app. Được gọi 1 chỗ duy nhất tại response interceptor của axios (helpers/api_helper.ts)
// — mọi nơi gọi API (APIClient, fakebackend_helper...) đều đi qua interceptor này nên tự động thừa
// hưởng, không cần tự xử lý riêng lẻ ở từng trang/service. Không để lộ message kỹ thuật/nội bộ hệ
// thống ra giao diện người dùng (VD "Request failed with status code 403", message tiếng Anh thô từ
// BE...) — đúng mục 3, README_SERCURITY.md.
//
// Mở rộng thêm status code khác (401, 404, 500...): chỉ cần thêm entry vào MESSAGES_BY_STATUS, không
// phải sửa gì ở nơi gọi.

export class HttpErrorMessageService {
  private static readonly MESSAGES_BY_STATUS: Record<number, string> = {
    403: st('ban_khong_co_quyen_truy_cap_text'),
    // Gateway / Cloudflare: service phía sau quá tải hoặc xử lý quá lâu (520-524 là mã riêng của Cloudflare).
    502: st('may_chu_dang_ban_text'),
    503: st('may_chu_dang_ban_text'),
    504: st('may_chu_phan_hoi_qua_lau_text'),
    520: st('may_chu_dang_ban_text'),
    522: st('may_chu_phan_hoi_qua_lau_text'),
    524: st('may_chu_phan_hoi_qua_lau_text'),
  };

  /**
   * Trả về message thân thiện cho status code đã định nghĩa; nếu status chưa được định nghĩa, giữ
   * nguyên fallbackMessage (message BE trả về hoặc message mặc định của axios).
   */
  static resolve(status: number | undefined, fallbackMessage: string): string {
    // Không có response (axios "Network Error", timeout, mất mạng, proxy cắt kết nối...) — không hiện
    // message kỹ thuật tiếng Anh ra giao diện.
    if (!status) {
      return st('khong_ket_noi_duoc_may_chu_text');
    }
    if (HttpErrorMessageService.MESSAGES_BY_STATUS[status]) {
      return HttpErrorMessageService.MESSAGES_BY_STATUS[status];
    }
    return fallbackMessage;
  }
}
